module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "svg-reach-chart",
    class: _vm.$style.root
  }, [_c('svg', {
    staticStyle: {
      "transform": "rotate(-0.25turn)"
    },
    attrs: {
      "viewBox": "-1 -1 2 2"
    }
  }, [_c('path', {
    staticClass: "slice-guaranteed",
    attrs: {
      "d": _vm.guaranteedSlice
    }
  }), _c('path', {
    staticClass: "slice-not-reached",
    attrs: {
      "d": _vm.notReachedSlice
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78c2753d"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg-reach-chart/SvgReachChart.vue
// module id = 948
// module chunks = 1